import { getCartItemQuantity } from '../get-cart-item-quantity';


function checkIsUpsellRequired(store) {
  const { getters } = store;

  const session = getters['session/session'];

  const order = getters['orders/order'];

  const upsellItems = getters['orders/upsellItems'];

  const { isTableTopDevice } = session.route;

  const { upsellDisplayMode, upsellRules } = order;

  const cartItemQuantity = getCartItemQuantity(order.orderItems);

  const isUpsellModalEnabled = upsellItems.checkoutUpsellItems.length > 0 && (upsellDisplayMode === 'Modal' || upsellDisplayMode === 'ModalCategory');

  const hasNoUpsellTargetAmounts = upsellRules?.every(upsellRule => !upsellRule.targetAmount);

  const hasMetUpsellTargetItemAmount = upsellRules?.find(upsellRule => upsellRule.targetAmount === cartItemQuantity);

  const hasExceededUpsellTargetItemAmount = upsellRules?.every(upsellRule => upsellRule.targetAmount <= cartItemQuantity);

  const upsellTargetDollarAmount = upsellRules?.find(upsellRule => Object.prototype.hasOwnProperty.call(upsellRule, 'triggerAmount'));

  const hasMetUpsellTargetDollarAmount = cartItemQuantity >= upsellTargetDollarAmount?.triggerAmount;

  const isUpsellRendered = hasMetUpsellTargetDollarAmount && !hasMetUpsellTargetItemAmount && !hasExceededUpsellTargetItemAmount;

  return isUpsellModalEnabled && (isTableTopDevice || hasNoUpsellTargetAmounts || isUpsellRendered);
}

export { checkIsUpsellRequired };
